import { useState, useEffect, useRef } from 'react';
import { Network } from '@capacitor/network';

export const useOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const listenerRef = useRef(null);

  useEffect(() => {
    let isMounted = true;

    const init = async () => {
      try {
        // Get initial status
        const status = await Network.getStatus();
        if (isMounted) {
          setIsOnline(status.connected);
        }

        // Add listener
        const handler = await Network.addListener('networkStatusChange', (status) => {
          if (isMounted) {
            setIsOnline(status.connected);
          }
        });
        listenerRef.current = handler;
      } catch (error) {
        console.error('Network listener error:', error);
      }
    };

    init();

    return () => {
      isMounted = false;
      if (listenerRef.current && typeof listenerRef.current.remove === 'function') {
        listenerRef.current.remove();
      }
    };
  }, []);

  return isOnline;
};